import { Checkbox, Group, Input, Stack } from '@mantine/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCanAccess } from '@mygpt/app';

import { useWidgetFormContext } from '@/components/Widget/Embed/form-context';
import { MultiLanguageTitle } from '@/components/Widget/Embed/Form/MultiLanguageTitle';
import { SuggestionMessage } from '@/components/Widget/Embed/Form/SuggestionMessages';
import { WelcomeMessage } from '@/components/Widget/Embed/Form/WelcomeMessage';
import { useWidgetForm } from '@/hooks/useWidgetForm';
import { useGPTStore } from '@/store';

import { SettingCard } from './SettingCard';

/** 文本与对话：欢迎语 / 推荐问题 / 输入占位 / 多语言标题（共用，小部件 + 纯聊天都生效） */
export const GeneralText = () => {
  const { t } = useTranslation();
  const { form } = useWidgetFormContext();
  const { onOverrideChangeForForm } = useWidgetForm();
  const { userInfo } = useGPTStore((state) => state);
  const canAccessWidgetCustomization = useCanAccess('enable_widget_customization');

  const digitalHumanAccess = useMemo(() => {
    const inviteValue = userInfo?.userconfigs.find((config) => config.key === 'enable_digital_human_interface');
    return inviteValue && inviteValue.value === 'True';
  }, [userInfo]);

  return (
    <SettingCard title={t('widget.setting.groups.card_text')}>
      {(opened) => (
        <Stack gap={20}>
          {digitalHumanAccess && <MultiLanguageTitle chatbotCollapseOpened={opened} />}
          <WelcomeMessage chatbotCollapseOpened={opened} />
          <SuggestionMessage chatbotCollapseOpened={opened} />
          <Group justify="space-between">
            <Checkbox
              disabled={!canAccessWidgetCustomization}
              label={t('widget.setting.chatbot.input_placeholder_label')}
              checked={form.values.chatbot.inputPlaceholder.checked}
              {...form.getInputProps('chatbot.inputPlaceholder.checked')}
              onChange={onOverrideChangeForForm('chatbot.inputPlaceholder.checked')}
            />
            <section className="w-[200px]">
              <Input
                disabled={!form.values.chatbot.inputPlaceholder.checked}
                autoComplete="off"
                {...form.getInputProps('chatbot.inputPlaceholder.value')}
                onBlur={onOverrideChangeForForm('chatbot.inputPlaceholder.value')}
              />
            </section>
          </Group>
          <Group justify="space-between" className="h-9 flex items-center">
            <Checkbox
              disabled={!canAccessWidgetCustomization}
              label={t('widget.setting.chatbot.hide_answer_source')}
              checked={form.values.chatbot.answerSource.checked}
              {...form.getInputProps('chatbot.answerSource.checked')}
              onChange={onOverrideChangeForForm('chatbot.answerSource.checked')}
            />
          </Group>
        </Stack>
      )}
    </SettingCard>
  );
};
